import { render, staticRenderFns } from "./databaseManagement.vue?vue&type=template&id=01d05e8e&scoped=true&"
import script from "./databaseManagement.vue?vue&type=script&lang=js&"
export * from "./databaseManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d05e8e",
  null
  
)

export default component.exports